import React from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { UserModal } from '../UserModal/UserModal';
import { useGCUserModal } from '../../hooks/useGCUserModal';

export interface InviteUserButtonProps {
    onRefresh: () => void;
}

export const InviteUserButton: React.FC<InviteUserButtonProps> = ({ onRefresh }) => {
    const modal = useGCUserModal(onRefresh);

    return (
        <>
            <Button
                id='inviteUserButton'
                theme={ButtonTheme.Primary}
                width='200px'
                height='40px'
                handleClick={modal.openNew}
            >
                Invite User
            </Button>
            <UserModal
                isOpen={modal.isOpen}
                onSubmitAsync={modal.onSubmitAsync}
                onClose={modal.close}
                authorizedDrawUser={modal.authorizedDrawUser}
            />
        </>
    );
};
